import axios from 'axios';

/* const API_URL = 'http://[2a02:8428:35a6:7001:2dbd:9493:86d9:48fa]:8000/openchat/'; */
const API_URL = 'https://nn-esc.hd.free.fr//openchat/';

export const postQuestion = async (userInput) => {
  try {
    const response = await axios.post(API_URL, { user_input: userInput });
    return response.data;
  } catch (error) {
    console.error("Error posting question", error);
    throw error;
  }
}; 

/*import axios from 'axios';
import ipv6AddressData from './ipv6_address.json';

// Function to get the API URL
const getApiUrl = () => {
  // Extract the IPv6 address from the JSON data
  const ipv6Address = ipv6AddressData.ipv6_address;
  if (ipv6Address) {
    return `http://[${ipv6Address}]:8000/openchat/`;
  } else {
    // Fallback URL if IPv6 address is not found
    return 'http://[default-ipv6-address]:8000/openchat/';
  }
};

// Use getApiUrl() to set API_URL
const API_URL = getApiUrl();

// Function to post a question
export const postQuestion = async (userInput) => {
  try {
    const response = await axios.post(API_URL, { user_input: userInput });
    return response.data;
  } catch (error) {
    console.error("Error posting question", error);
    throw error;
  }
}; */


/*import axios from 'axios';

// Function to dynamically fetch the API base URL
const getApiUrl = async () => {
  try {
    // Fetch the IPv6 address from the remote JSON file
    const response = await axios.get('https://location-immo-vente.com/react/ipv6_address.json');
    const ipv6Address = response.data.ipv6_address;

    if (ipv6Address) {
      //return `http://[${ipv6Address}]:8000/openchat/`;
      return `https://[${ipv6Address}]:8000/openchat/`;
    } else {
      // Fallback URL if IPv6 address is not found
      return 'http://[default-ipv6-address]:8000/openchat/';
    }
  } catch (error) {
    console.error("Error fetching IPv6 address from remote file", error);
    // Fallback URL in case of error
    return 'http://[default-ipv6-address]:8000/openchat/';
  }
};

// Function to post a question using the dynamic API URL
export const postQuestion = async (userInput) => {
  const API_URL = await getApiUrl();
  try {
    const response = await axios.post(API_URL, { user_input: userInput });
    return response.data;
  } catch (error) {
    console.error("Error posting question", error);
    throw error;
  }
}; */









